<template>

	<b-container class="text-center">
		<b-row>
			<b-col cols="12" md="4" lg="4" v-for="offer in offersList" :key="offer.id" class="p-4">
				<OfferCard :offer="offer" />
			</b-col>
		</b-row>
	</b-container>

</template>

<script>

	import api from '@js/api';
	import OfferCard from './OfferCard.vue';

	export default {
		components: {
			OfferCard
		},

		props: {
			offers: Array
		},

		data() {
			return {
				offersList: this.offers,
			};
		},

		async beforeMount() {
			/* If the products aren't passed in as a prop, get them from the api */
			if (!this.offersList) {
				let response = await api.getShopOffers();
				let validOffers = response.data.filter(offer => offer.media.length > 0);
				this.offersList = validOffers.slice(0, 3);
			}
		}
	}

</script>
